import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomDialogComponent } from '../../component/custom-dialog/custom-dialog.component';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { RejectModalComponent } from '../../component/reject-modal/reject-modal.component';
import { ViewerComponent } from '../../component/viewer/viewer.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
//import { CustomDatepickerTypeComponent } from '../../Formly/custom-types/custom-datepicker.type';
import { CalendarModule } from 'primeng/calendar'
import { FormlyFormFieldModule } from '@ngx-formly/primeng/form-field';
import { TruncatePipe } from '../../Pipes/truncated.pipe';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { CustomToastComponent } from '../../component/custom-toast/custom-toast.component';
import { ReviewModalComponent } from '../../component/review-modal/review-modal.component';
import { TableModule } from 'primeng/table';
import { CheckboxModule } from 'primeng/checkbox';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DropdownModule } from 'primeng/dropdown';
import { RouterModule } from '@angular/router';
import { FormlyFieldFileUploadComponent } from '../users/types/formly-field-file-upload.component';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyPrimeNGModule } from '@ngx-formly/primeng';
import { FormlyFieldMultiFile } from '../service-provider/multiFile-type';
import { FormlyFieldFile } from '../service-provider/file-type';
import { MapLocationComponent } from '../../location/map-location/map-location.component';
import { AddressproofComponent } from '../../location/addressproof/addressproof.component';
import { CustomDateTypeComponent } from '../../Formly/custom-types/custom-datepicker-min.type';
import { FieldFilesUploadComponent } from '../../Formly/custom-types/custom-file-picker.component';
import { ServiceProviderSelectorComponent } from '../../service-distributor/type/formly-selector-type';
import { ButtonTypeComponent } from '../../service-distributor/type/button-type';
import { FormlyFieldButton } from '../../Formly/custom-types/button-type.component';
import { MakePaymentComponent } from '../../component/make-payment/make-payment.component';
import { AddBalanceWalletComponent } from '../../component/add-balace-wallet/add-balace-wallet.component';
import { SliderModule } from 'primeng/slider';
import { InputTextModule } from 'primeng/inputtext';
import { CustomRangeSliderDirective } from '../../directives/range.directive';
import { TooltipModule } from 'primeng/tooltip';
import { AddBalanceComponent } from '../Dashboard/dashboard/add-balance/add-balance.component';
import { DistributorWalletComponent } from '../../component/distributor-wallet/distributor-wallet.component';
import { LoaderComponent } from '../../component/loader/loader.component';
import { ELockerComponent } from '../Locker/e-locker/e-locker.component';
import { RechargeWalletPopupComponent } from '../../component/recharge-wallet-popup/recharge-wallet-popup.component';
import { PermissionWrapperComponent } from '../../component/permission-wrapper/permission-wrapper.component';
import { PeriodSelectorComponent } from '../user-dashboard/period-selector/period-selector.component';
import { CustomDateRangePickerComponent } from '../user-dashboard/period-selector/custom-date-range-picker/custom-date-range-picker.component';
import { PromotionDashboardComponent } from '../../component/promotion-dashboard/promotion-dashboard.component';
import { TabViewModule } from 'primeng/tabview';
import { PromotionDashboardTabsComponent } from '../../component/promotion-dashboard/promotion-dashboard-tabs/promotion-dashboard-tabs.component';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
//import { AddDocumentComponent } from '../Locker/add-document/add-document.component';
import { FloatLabelModule } from 'primeng/floatlabel';
import { PromotionAnalyticsComponent } from '../../component/promotion-analytics/promotion-analytics.component';
import { NgChartsModule } from 'ng2-charts';
import { MarkDisableComponent } from '../../component/mark-disable/mark-disable.component';


@NgModule({
  declarations: [
    CustomDialogComponent,
    RejectModalComponent,
    ViewerComponent,
    TruncatePipe,
    ReviewModalComponent,
    FormlyFieldFileUploadComponent,
    MapLocationComponent,
    AddressproofComponent,
    CustomDateTypeComponent,
    FieldFilesUploadComponent,
    ServiceProviderSelectorComponent,
    FormlyFieldButton,
    MakePaymentComponent,
    AddBalanceWalletComponent,
    CustomRangeSliderDirective,
    AddBalanceComponent,
    RechargeWalletPopupComponent,
    PermissionWrapperComponent,
    PeriodSelectorComponent,
    CustomDateRangePickerComponent,
    PromotionDashboardComponent,
    PromotionDashboardTabsComponent,
    PromotionAnalyticsComponent,
    MarkDisableComponent,
    // ELockerComponent,
    // AddDocumentComponent
  ],
  exports: [
    CustomDialogComponent,
    RejectModalComponent,
    ViewerComponent,
    TruncatePipe,
    ReviewModalComponent,
    FormlyFieldFileUploadComponent,
    MapLocationComponent,
    AddressproofComponent,
    CustomDateTypeComponent,
    FieldFilesUploadComponent,
    ServiceProviderSelectorComponent,
    FormlyFieldButton,
    MakePaymentComponent,
    AddBalanceWalletComponent,
    CustomRangeSliderDirective,
    AddBalanceComponent,
    RechargeWalletPopupComponent,
    PermissionWrapperComponent,
    PeriodSelectorComponent,
    CustomDateRangePickerComponent,
    PromotionDashboardComponent,
    PromotionDashboardTabsComponent,
    PromotionAnalyticsComponent,
    NgChartsModule,
    MarkDisableComponent,
    FormsModule,
    // ELockerComponent,
    // AddDocumentComponent
  ],
  imports: [
    NgChartsModule,
    SliderModule,
    IconFieldModule,
    InputIconModule,
    InputTextModule,
    FloatLabelModule,
    InputTextModule,
    TableModule,
    DropdownModule,
    CheckboxModule,
    RadioButtonModule,
    ToastModule,
    CalendarModule,
    FormsModule,
    ReactiveFormsModule,
    PdfViewerModule,
    CommonModule,
    DialogModule,
    ButtonModule,
    TabViewModule,
    FormlyFormFieldModule,
    NgxExtendedPdfViewerModule,
    // PdfViewerModule,
    RouterModule,
    TooltipModule,
    ReactiveFormsModule,
    FormlyPrimeNGModule,
    FormlyModule.forChild({
      types: [
        {
          name: 'multifile',
          component: FormlyFieldMultiFile,
        },
        { name: 'file', component: FormlyFieldFile, wrappers: ['form-field'] },
        {
          name: 'custom-min-dt',
          component: CustomDateTypeComponent
        },
        { name: 'f-file-upload', component: FieldFilesUploadComponent },
        { name: 'service-provider-selector', component: ServiceProviderSelectorComponent },
        { name: 'button', component: FormlyFieldButton },
      ],

    }),
  ]
})
export class SharedModule { }
